import interruptionPoint from './interruption-points';

const getInterruptionPoint = (actionType) => interruptionPoint.get(actionType);

export default getInterruptionPoint;
